"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const use_lazy_promise_1 = require("../../hook/use-lazy-promise");
const sign_in_1 = require("../../network/sign-in");
const material_1 = require("@mui/material");
const password_field_1 = require("../../component/input/password-field");
const react_router_dom_1 = require("react-router-dom");
const alert_context_1 = require("../../context/alert-context");
const button_1 = require("../../component/input/button");
const log_1 = require("../../model/log");
const reset_password_dialog_1 = require("./reset-password-dialog");
const log_view_layout_1 = require("../../component/log-view-layout");
exports.SignInPage = (0, react_1.memo)(() => {
    const theme = (0, material_1.useTheme)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { status, execute, error } = (0, use_lazy_promise_1.useLazyPromise)(sign_in_1.signIn);
    const { showAlert } = (0, alert_context_1.useAlert)();
    const [resetPasswordDialogOpen, setResetPasswordDialogOpen] = (0, react_1.useState)(false);
    const formik = (0, formik_1.useFormik)({
        initialValues: {
            email: "",
            password: "",
        },
        validateOnChange: false,
        validateOnBlur: false,
        validate: (values) => {
            const errors = {};
            if (!/\S+@\S+\.\S+/.test(values.email)) {
                errors.email = "Email is invalid";
                return errors;
            }
            if (values.password.length < 6) {
                errors.password = "Password must be at least 6 characters";
                return errors;
            }
        },
        onSubmit: (values) => {
            execute(values.email, values.password);
        },
    });
    (0, react_1.useEffect)(() => {
        if (status === use_lazy_promise_1.FetchStatus.Success) {
            navigate("/home");
        }
    }, [status, formik, navigate]);
    (0, react_1.useEffect)(() => {
        if (status === use_lazy_promise_1.FetchStatus.Error) {
            showAlert((error === null || error === void 0 ? void 0 : error.message) || "Sign in failed", alert_context_1.AlertType.Error);
        }
    }, [status, error, showAlert]);
    const submitEnabled = (0, react_1.useMemo)(() => {
        return formik.values.email.length > 0 && formik.values.password.length > 0;
    }, [formik.values.email, formik.values.password]);
    const handleSignUp = (0, react_1.useCallback)(() => {
        navigate("/sign-up");
    }, [navigate]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { overflow: "auto", direction: "column", alignItems: "center", justifyContent: "center", style: {
            flexGrow: 1,
        }, children: [(0, jsx_runtime_1.jsx)(log_view_layout_1.LogViewLayout, { eventName: log_1.LogEventViewName.SignInPage }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h4", fontWeight: theme.typography.fontWeightBold, color: "primary", marginBottom: theme.spacing(4), textAlign: "center", children: "Sign In" }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", alignItems: "center", spacing: 4, width: theme.spacing(50), marginBottom: theme.spacing(16), children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { label: "Email", variant: "outlined", fullWidth: true, value: formik.values.email, onChange: formik.handleChange, error: Boolean(formik.errors.email), helperText: formik.errors.email, name: "email" }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", alignItems: "start", justifyContent: "space-between", width: "100%", children: [(0, jsx_runtime_1.jsx)(password_field_1.PasswordField, { label: "Password", variant: "outlined", fullWidth: true, value: formik.values.password, onChange: formik.handleChange, error: Boolean(formik.errors.password), helperText: formik.errors.password, name: "password" }), (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "text", color: "primary", eventName: log_1.LogEventClickName.ForgotPassword, onClick: () => setResetPasswordDialogOpen(true), children: "Forgot Password?" })] }), (0, jsx_runtime_1.jsx)(button_1.Button, { size: "large", variant: "outlined", color: "primary", eventName: log_1.LogEventClickName.SignInPageSignIn, onClick: formik.submitForm, disabled: !submitEnabled, startIcon: status === use_lazy_promise_1.FetchStatus.Loading && ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { sx: { width: theme.spacing(2), height: theme.spacing(2) }, size: "small", color: "primary" })), fullWidth: true, children: "Sign In" }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", justifyContent: "center", spacing: 2, width: "100%", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", color: "textSecondary", children: "Don't have an account?" }), (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "text", color: "primary", eventName: log_1.LogEventClickName.SignInPageSignUp, onClick: handleSignUp, children: "Sign Up" })] })] }), (0, jsx_runtime_1.jsx)(reset_password_dialog_1.ResetPasswordDialog, { open: resetPasswordDialogOpen, onClose: () => setResetPasswordDialogOpen(false) })] }));
});
exports.SignInPage.displayName = "SignInPage";
exports.default = exports.SignInPage;
